export const TAB_NAMES = {
  MAIN: 'main',
  CHANNEL: 'channel',
  LAYOUT: 'layout',
  SETTINGS: 'settings',
  PLAYER: 'player',
  DESIGN: 'design',
};

export const TAB_NAMES_LIST_OLD = [
  TAB_NAMES.MAIN,
  TAB_NAMES.CHANNEL,
  TAB_NAMES.LAYOUT,
  TAB_NAMES.SETTINGS,
  TAB_NAMES.DESIGN,
];

export default [
  TAB_NAMES.MAIN,
  TAB_NAMES.CHANNEL,
  TAB_NAMES.LAYOUT,
  TAB_NAMES.PLAYER,
  TAB_NAMES.SETTINGS,
  TAB_NAMES.DESIGN,
];



// WEBPACK FOOTER //
// ./src/shared/constants/app-settings-tabs.js